export namespace TrackingActions {
    export class Push {
        static readonly type = '[TRACKING] Push Datalayer'
        constructor(public event:string,public data:any) { }
    }
}
